const TUPLE_LENGTHS = { translation: 3, rotation: 4, scale: 3 } as const;

/** Validate authored numeric TRS, not Properties' separately resolved overrides. */
export function assertValidTransformData(transform: unknown, nodeName: string): void {
    if (transform === undefined) return;
    if (transform === null || typeof transform !== 'object' || Array.isArray(transform)) {
        throw new Error(`Invalid transform on node ${JSON.stringify(nodeName)}: expected an object.`);
    }
    const parent = (transform as Record<string, unknown>).parent;
    const path = typeof parent === 'string' && parent ? `${parent}/${nodeName}` : nodeName;

    for (const field of Object.keys(TUPLE_LENGTHS) as Array<keyof typeof TUPLE_LENGTHS>) {
        const tuple = (transform as Record<string, unknown>)[field];
        if (tuple === undefined) continue;
        if (!Array.isArray(tuple) || tuple.length !== TUPLE_LENGTHS[field]
            || !Array.from(tuple).every(value => typeof value === 'number' && Number.isFinite(value))) {
            throw new Error(
                `Invalid transform.${field} on node ${JSON.stringify(path)}: `
                + `expected ${TUPLE_LENGTHS[field]} finite numbers.`,
            );
        }
    }
}
